// extracted by mini-css-extract-plugin
var _1 = "AccordionAnimatedContent-moduleAccordionAnimatedContent__ScEWQ";
var _2 = "AccordionAnimatedContent-moduleAccordionAnimatedContentWrapper__Jl0wS";
var _3 = "AccordionAnimatedContent-moduleopened__n_Df5";
export { _1 as "AccordionAnimatedContent", _2 as "AccordionAnimatedContentWrapper", _3 as "opened" }
